import { render, staticRenderFns } from "./StaffDetailByRoundModal.vue?vue&type=template&id=7354d61a&scoped=true&"
import script from "./StaffDetailByRoundModal.vue?vue&type=script&lang=js&"
export * from "./StaffDetailByRoundModal.vue?vue&type=script&lang=js&"
import style0 from "./StaffDetailByRoundModal.vue?vue&type=style&index=0&id=7354d61a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7354d61a",
  null
  
)

export default component.exports